import { html, SYSBaseElement } from "../../../../_ovlclient/src"
import { T } from "../../../../_ovlclient/src/global/globals"
import type { SYSTableDefIds } from "../../../../_ovlclient/src"

export class ScreenSYSTranslation extends SYSBaseElement {
  async getUI() {
    return html`
      <div class="fd-layout-panel ">
        <div class="fd-layout-panel__body ">
          <ovl-table
            class="fd-table fd-table--no-horizontal-borders"
            .props=${() => <SYSTableDefIds>"SYSTranslation"}
          >
          </ovl-table>
        </div>
      </div>
    `
  }
}
